import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  Inject,
  NgZone,
  OnInit,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AuthServiceService } from 'src/app/shareModule/services/auth-service.service';
import { LocalServiceService } from 'src/app/shareModule/services/local-service.service';
import { environment } from 'src/environments/environment';
import moment from 'moment';
import {
  NgbDateStruct,
  NgbModal,
  NgbModalRef,
} from '@ng-bootstrap/ng-bootstrap';
import { MarketplacePageComponent } from 'src/app/customers/marketplace/marketplace.component';
import { Location } from '@angular/common';
import { HttpEventType } from '@angular/common/http';
import { Title } from '@angular/platform-browser';
import {
  filter,
  forkJoin,
  Observable,
  Subject,
  Subscription,
  takeUntil,
} from 'rxjs';
import { SharedService } from 'src/app/shareModule/services/shared.service';
import { CustomerService } from 'src/app/shareModule/services/customer.service';
import { ApiResponse } from 'src/app/shareModule/models/common.model';
import { select, Store } from '@ngrx/store';
import { loadUser, selectUser } from 'src/app/shareModule/states/user-details';
import { User } from 'src/app/shareModule/models/user.model';
import confetti from 'canvas-confetti';
import { Clipboard } from '@angular/cdk/clipboard';
import domtoimage from 'dom-to-image';
import { AppState } from 'src/app/shareModule/states/app.state';
import {
  loadBizShopProducts,
  selectBizShopProducts,
} from 'src/app/shareModule/states/biz-shop-product';
import { BizProduct } from 'src/app/shareModule/models/biz-product.model';
import { BizShopBanner } from 'src/app/shareModule/models/biz-shop-banner';
import {
  loadBizShopBanner,
  selectBizShopBanner,
} from 'src/app/shareModule/states/biz-shop-banner';
import { SeoService } from 'src/app/shareModule/services/seo.service';
import { SignInComponent } from '../../layout/component-layout/sign-in/sign-in.component';
import html2canvas from 'html2canvas';
import { VerifyEmailPopupComponent } from 'src/app/shareModule/component/verify-email-popup/verify-email-popup.component';
import { CommonService } from 'src/app/shareModule/services/common.service';
import { RoleService } from 'src/app/shareModule/services/roles/role.service';
import {
  MatBottomSheet,
  MatBottomSheetRef,
} from '@angular/material/bottom-sheet';

declare const google: any;
@Component({
  selector: 'app-marketplace-shop-detail',
  templateUrl: './marketplace-shop-detail.component.html',
  styleUrls: ['./marketplace-shop-detail.component.scss'],
})
export class MarketplaceShopDetailComponent implements OnInit {
  colorClasses = ['m-bg-primary', 'm-bg-pink'];
  /********************* code reltated to reward and claims ******************************/
  public isRewardMode = false;
  public allRewards = [];
  public _getAllRewards() {
    this.auth.getAllClaimableRewards().subscribe({
      next: (data) => {
        this.allRewards = data.body;
        this.cdr.detectChanges();
      },
      error: console.error,
    });
  }
  public encodedCenteralRewardImage = null;

  @ViewChild('confirmYesNo')
  public confirmYesNo: TemplateRef<any>;

  public selectedReward = null;
  private bottomSheetRef: MatBottomSheetRef | null = null;
  public confirmYes() {
    this.auth.claimAReward(this.selectedReward.id).subscribe({
      next: () => {
        this.toastr.success('Reward claimed we will contact you shorty'),
          this._getAllRewards();
        this.bottomSheetRef?.dismiss();
        this.bottomSheetRef = null;
      },
      error: (err) => {
        this.toastr.error(
          'Something went wrong while claiming reeward: ' + err.error.message
        );
      },
    });
  }
  public noSelected() {
    this.bottomSheetRef?.dismiss();
    this.bottomSheetRef = null;
  }

  public claimReward(reward) {
    this.selectedReward = reward;

    if (this.isMobile) {
      this.bottomSheetRef = this.bottomSheet.open(this.confirmYesNo, {
        panelClass: 'bottom-sheet-1',
      });
    } else {
      setTimeout(() => {
        this.local
          .confirmYesNo({
            title: 'Are you sure you want to claim this reward',
            text: `This reward requires ${reward.pointsNeeded} point${
              reward.pointsNeeded > 1 ? 's' : ''
            }`,
            icon: 'info',
          })
          .then((res) => {
            if (res.isConfirmed) {
              this.confirmYes();
            }
          });
      });
    }
  }

  public reward = {
    id: '',
    description: '',
    pointsNeeded: null,
    slashedPoints: null,
    maxClaimableCount: null,
    centeralImage: null,
    //  isAvailable: false
  };
  @ViewChild('rewardModal')
  public rewardForm;

  public get isMobile(): boolean {
    return this.sharedService.isBrowser() && window.innerWidth <= 767;
  }

  isRewardEditingMode = false;
  openEditReward(reward) {
    reward.description = reward.descritpion;
    this.reward = reward;
    this.openRewardForm(true);
  }

  openRewardForm(isRewardEditingMode = false) {
    this.isRewardEditingMode = isRewardEditingMode;
    if (this.isMobile) {
      this.bottomSheet.open(this.rewardForm, { panelClass: 'bottom-sheet-1' });
    } else {
      this.modalService.open(this.rewardForm);
    }
  }
  public setImageForNewClaimableReward(event) {
    const file = event.target.files[0];
    const fileReader = new FileReader();
    fileReader.onload = () => {
      this.encodedCenteralRewardImage = fileReader.result;
    };
    fileReader.readAsDataURL(file);
    this.reward.centeralImage = file;
  }
  public selectClaimableRewardImage() {
    document.getElementById('select-claimable-reward-image').click();
  }
  public deleteReward(reward) {
    this.local
      .confirmYesNo({
        title: 'Delete Reward?',
        text: 'Are you sure you want to remove this reward?',
        icon: 'warning',
      })
      .then((val) => {
        if (val.isConfirmed) {
          return this.auth.deleteClaimableReward(reward?.id).subscribe({
            next: (data) => {
              this.toastr.success('Done');
              this._getAllRewards();
              this.modalService.dismissAll();
            },
            error: console.error,
          });
        }
      });
  }
  public submitReward(): void {
    console.log('Reward saved:', this.reward);
    const payload = new FormData();
    payload.append('descritpion', this.reward.description);
    payload.append('pointsNeeded', this.reward.pointsNeeded);
    payload.append('slashedPoints', this.reward.slashedPoints);
    payload.append('maxClaimableCount', this.reward.maxClaimableCount);
    payload.append('centeralImage', this.reward.centeralImage);

    let obs: Observable<ApiResponse> = null;
    if (!this.isRewardEditingMode) {
      obs = this.auth.createClaimableReward(payload);
    } else {
      obs = this.auth.editClaimableReward(this.reward?.id, payload);
    }

    // payload.append('isAvailable', this.reward.isAvailable);

    obs.subscribe({
      next: (data) => {
        this.toastr.success('Done');
        this._getAllRewards();
        this.modalService.dismissAll();
      },
      error: console.error,
    });
  }
  /************************************************************************************ */

  handleChatNow() {
    const params = {
      chatingNow: this.profile.id,
      menu: 'chat',

      chatTitle: 'Unknown',
      lastSeenTime: '...',
      productName: null,
      productImage: null,
      productPrice: null,
      productId: null,
      isBiz: true,
    };
    this.auth.get_chat_data(this.profile?.id, true).subscribe({
      next: (data) => {
        if (data['chatData']['doesBizHaveABot']) {
          this.sharedService.triggerChatNow(params);
        } else {
          this.toastr.info('Biz Owner has not registered a telegram account');
        }
      },
      error: (err) => {
        console.error(err);
        this.toastr.error('Something went wrong please try again latter');
      },
    });
  }

  animateRose: boolean = false;
  animateDiamond: boolean = false;
  listOptions: boolean = false;
  modeCardBusiness: boolean = false;
  celebrate() {
    const duration = 3000; // in milliseconds

    confetti({
      particleCount: 100,
      spread: 160,
      origin: { y: 0.6 },
      colors: ['FFE400', 'FFBD00', 'E89400', 'FFCA6C', 'FDFFB8'],
    });

    // Clear confetti after a certain duration
    setTimeout(() => confetti.reset(), duration);
  }
  playDiamond() {
    this.animateDiamond = true;
    setTimeout(() => {
      this.animateDiamond = false;
    }, 2000);
  }

  menuSliderLeft: boolean = false;
  @ViewChild('marketplace') marketplaceProfileSection: MarketplacePageComponent;
  @ViewChild('VoucherTermsAndConditionsModal')
  VoucherTermsAndConditionsModal: TemplateRef<any>;
  public imgUrl = environment.ImageUrl;
  viewGrid: boolean = true;
  loading = true;
  loadingCate = false;
  loadingProduct = true;
  public selectedCategoryName = null;
  public selectedSubCategoryName = '';
  public addedCategoryList: Array<any> = [];
  public addedSubCategoryList: Array<any> = [];
  public profile: any = {
    appUserCertificates: [],
    memberSupports: [],
  };
  currBizCard = {};
  public user: any = {};
  appUserId: any;
  isLogin: any = 0;
  referralCode: string = '';
  userReferralUploadedFile: any = [];
  category: string = 'news';
  refferalCategories: any = [
    // { title: 'news' },
    // { title: 'gallery' },
    // { title: 'cashback' },
    // { title: 'voucher' },
  ];
  getIndexByName(title: string): number {
    return this.refferalCategories.findIndex(
      (category) => category.title === title
    );
  }
  carouselOptionsEmployee: any = {
    spaceBetween: 15,
    slidesPerView: 1,
    // pagination: false,
    breakpoints: {
      640: {
        slidesPerView: 2,
      },
      1024: {
        slidesPerView: 2,
      },
      1200: {
        slidesPerView: 3,
      },
    },
  };
  carouselOptions: any = {
    spaceBetween: 15,
    slidesPerView: 'auto',
    pagination: false,
  };
  carouselOptionsCate: any = {
    spaceBetween: 15,
    slidesPerView: 'auto',
    pagination: false,
  };
  moreContent: boolean = false;
  tabCategorie: number = 0;
  isPhoto: boolean = true;
  public productAllProductList: Array<any> = [];
  public page: any;
  public totalPages: any;
  public currentPage: any;
  public get_all_product_banner_response: Array<any> = [];
  public shopAdminId: any;
  private destroy$ = new Subject<void>(); // Emits on destroy

  /******************************************** Edit Service Page *************************/

  public encodedBannerImage = null;
  @ViewChild('changeProductPageInfo')
  public changeProductPageInfo: TemplateRef<any>;
  private selectedBannerImage: File | null = null;
  public setBannerImage(event) {
    const file = event.target.files[0];
    this.selectedBannerImage = file;

    const fr = new FileReader();
    fr.onload = (event: any) => {
      this.encodedBannerImage = event.target.result;
    };
    fr.readAsDataURL(file);
  }
  @ViewChild('bannerImageSelector')
  public bannerImageSelector;
  public selectBannerImages(e) {
    e.stopPropagation();
    const nativeFileSelector = this.bannerImageSelector.nativeElement;
    nativeFileSelector.click();
  }
  isAdmin: boolean = false;

  public openChangeProductPageInfo(event) {
    event.stopPropagation(); //no diamonds here
    if (!this.isAdmin && this.serviceData?.memberId != this.user.id) {
      return; //doesnt have a claim
    }

    this.modalService.open(this.changeProductPageInfo, { size: 'sm' });
  }
  private selectedProfileImage = null;
  public setProfileImage(event) {
    const file = event.target.files[0];
    this.selectedProfileImage = file;

    const fr = new FileReader();
    fr.onload = (event: any) => {
      this.encodedProfileImage = event.target.result;
    };
    fr.readAsDataURL(file);
  }

  public submitPageData() {
    const payload = new FormData();
    if (this.selectProfileImage) {
      payload.append('profileImage', this.selectedProfileImage);
    }
    if (this.selectedBannerImage) {
      payload.append('bannerImage', this.selectedBannerImage);
    }
    this.auth.setProductPageInfos(this.serviceData?.id, payload).subscribe({
      next: (data) => {
        this.toastr.success('submited!');
        this.modalService.dismissAll();
        this._getServiceData();
      },
      error: (err) => {
        console.error(err);
        this.toastr.error('Something went wrong please try again latter');
      },
    });
  }

  @ViewChild('profileImageSelector')
  public profileImageSelector;
  public encodedProfileImage = null;
  public selectProfileImage(e) {
    e.stopPropagation();
    const nativeFileSelector = this.profileImageSelector.nativeElement;
    nativeFileSelector.click();
  }
  public closeModals() {
    this.modalService.dismissAll();
  }
  /************************************************************************************ */

  constructor(
    private route: ActivatedRoute,
    private local: LocalServiceService,
    private auth: AuthServiceService,
    private toastr: ToastrService,
    private modalService: NgbModal,
    private _location: Location,
    private router: Router,
    private title: Title,
    private sharedService: SharedService,
    private customerService: CustomerService,
    private store: Store<AppState>,
    private ngZone: NgZone,
    private clipboard: Clipboard,
    private seoService: SeoService,
    private commonService: CommonService,
    private cdr: ChangeDetectorRef,
    private roleService: RoleService,
    private bottomSheet: MatBottomSheet,
    @Inject('WINDOW') private window: any
  ) {}

  @ViewChild('SignIn', { static: false }) signIn: SignInComponent;

  public openSigninModal(): void {
    //this.signIn.loginStage = '';
    this.signIn.withoutSteps = true;
    this.signIn.openSignInPopup();
  }

  private getChatBotData() {
    this.auth.get_chat_data(this.profile?.id, true).subscribe({
      next: (data) => {
        if (data['chatData']['doesBizHaveABot']) {
          this.bizHasBot = true;
        } else {
          this.bizHasBot = false;
        }
      },
    });
  }
  public closeAllPop() {
    this.modalService.dismissAll();
  }
  public timeAgo(time) {
    return this.local.timeAgo(time);
  }

  public variantToProduct(variant) {
    const t = {
      name: variant.value,
      indexImage: variant.image,
      price: variant.key,
      memberShopProductsVariations: [{ key: variant.key }],
    };
    console.log(t);
    return t;
  }

  public isServiceMode = false;
  private _roleSubscription?: Subscription | null = null;
  ngOnInit(): void {
    this._roleSubscription = this.roleService.rolesSubject.subscribe(() => {
      this.isAdmin = this.roleService?.roles?.userType.includes('ADMIN');
      this.cdr.detectChanges();
    });

    this.store
      .pipe(select(selectUser))

      .subscribe((response: User) => {
        this.user = response;
      });

    this.loading = true;
    this.checkIfLogin();
    if (this.modalService) {
      this.modalService.dismissAll();
    }
    if (this.router.url.includes('/rewards')) {
      this.isServiceMode = false;
      this.isRewardMode = true;
      this._getAllRewards();
    } //reusing same compoentn here
    else if (this.route.snapshot.params.shop) {
      this.shopAdminId = this.route.snapshot.params.shop;

      console.log('this is the shop admin id', this.shopAdminId);
      if (this.router.url.includes('/biz')) {
        this.getProfileInfo(this.route.snapshot.params.shop);
        console.log('This is a biz');
        forkJoin([
          this.getAllCategories(this.shopAdminId),
          this.getShopMember(this.shopAdminId),
        ]).subscribe({
          next: (results: any) => {
            const [categories, shopMember] = results;
            this.categories = categories.body;
            this.memberList = shopMember.body;
            this.loading = false;
          },
          error: (err) => {
            this.loading = false;
          },
        });
        this.route.queryParams.subscribe((params) => {
          if (params['code']) {
            this.referralCode = params['code'];
            this.getReferralInfo(params['code']);
          }
        });

        this.getPageData();
      } else {
        this.isServiceMode = true;
        this._getServiceData();
        console.log('this is a service');
      }
    }
  }
  myReferalCode = '';
  serviceData = null;
  private _getServiceData() {
    this.auth
      .getShopProductDetails({ productId: this.shopAdminId, isForPage: 1 })
      .subscribe({
        next: (data) => {
          this.serviceData = data.body;
          this.loading = false;
          this.cdr.detectChanges();
        },
        error: (err) => {
          console.error(err);
          this.toastr.error('Error could not find the product data');
          this.loading = false;
          this.cdr.detectChanges();
        },
      });
  }

  public getPageData(): void {
    this.get_all_product_banner_response = [];
    // get User Details
    this.store
      .pipe(select(selectUser))

      .subscribe((response: User) => {
        this.user = response;
      });
    // get Shop Product Details
    this.store
      .pipe(select(selectBizShopProducts))
      .subscribe(
        (response: {
          currentPage: number;
          data: BizProduct[];
          nextPage: number;
          pageSize: number;
          prevPage: number;
          totalItems: number;
          totalPages: number;
        }) => {
          let resp = structuredClone(response);
          this.totalPages = resp.totalPages;
          this.currentPage = resp.currentPage;
          resp.data.map((e) => {
            e.user_detail = {};
          });
          if (this.page > 1) {
            this.productAllProductListFiltered.push(...resp.data);
            this.readmore = false;
          } else {
            this.productAllProductListFiltered = resp.data;
          }

          this.loadingProduct = false;
        }
      );

    // get Shop banner
    this.store
      .pipe(select(selectBizShopBanner))
      .subscribe((response: Array<BizShopBanner>) => {
        this.get_all_product_banner_response = response;
      });
  }

  openCardBusinessModal(modal) {
    this.modalService.open(modal, {
      windowClass: 'my-modal ',
    });
  }
  openCardPosterModal(modal) {
    this.modalService.open(modal, {
      windowClass: 'my-modal ',
    });
  }
  openListOptionsModal(modal) {
    this.modalService.open(modal, {
      windowClass: 'my-modal md',
    });
  }

  @ViewChild('cardBusiness') cardBusiness!: ElementRef;
  downloadCardBusiness() {
    const scale = 4; // Increase this value for ultra-high resolution (e.g., 4x, 5x)
    const options = {
      quality: 1, // Highest quality (maximum is 1)
      width: this.cardBusiness.nativeElement.offsetWidth * scale,
      height: this.cardBusiness.nativeElement.offsetHeight * scale,
      style: {
        transform: `scale(${scale})`,
        transformOrigin: 'top left',
      },
      useCORS: true,
    };

    domtoimage
      .toJpeg(this.cardBusiness.nativeElement, options)
      .then((dataUrl) => {
        const link = document.createElement('a');
        link.download = 'card-biz.jpeg';
        link.href = dataUrl;
        link.click();
      })
      .catch((error) => {
        console.error('Error creating image:', error);
      });
  }
  CardBusinessWidthLogo: number = 12;
  @ViewChild('cardBusiness2') cardBusiness2!: ElementRef;
  downloadCardBusiness2() {
    const scale = 4; // Increase this value for ultra-high resolution (e.g., 4x, 5x)
    const options = {
      quality: 1, // Highest quality (maximum is 1)
      width: this.cardBusiness2.nativeElement.offsetWidth * scale,
      height: this.cardBusiness2.nativeElement.offsetHeight * scale,
      style: {
        transform: `scale(${scale})`,
        transformOrigin: 'top left',
      },
    };

    domtoimage
      .toJpeg(this.cardBusiness2.nativeElement, options)
      .then((dataUrl) => {
        const link = document.createElement('a');
        link.download = 'card-biz-basic.jpeg';
        link.href = dataUrl;
        link.click();
      })
      .catch((error) => {
        console.error('Error creating image:', error);
      });
  }

  @ViewChild('cardPoster') cardPoster!: ElementRef;
  downloadCardPoster() {
    const scale = 4; // Increase this value for ultra-high resolution (e.g., 4x, 5x)
    const options = {
      quality: 1, // Highest quality (maximum is 1)
      width: this.cardPoster.nativeElement.offsetWidth * scale,
      height: this.cardPoster.nativeElement.offsetHeight * scale,
      style: {
        transform: `scale(${scale})`,
        transformOrigin: 'top left',
      },
    };

    domtoimage
      .toJpeg(this.cardPoster.nativeElement, options)
      .then((dataUrl) => {
        const link = document.createElement('a');
        link.download = 'card-poster.jpeg';
        link.href = dataUrl;
        link.click();
      })
      .catch((error) => {
        console.error('Error creating image:', error);
      });
  }
  goBack() {
    this.commonService.goBack();
  }

  checkIfLogin() {
    this.isLogin = !!this.local.getUser();
    this.local.getUserDetailsObserver().subscribe((user) => {
      if (user?.id) {
        this.myReferalCode = user.referralCode;
        this.appUserId = user.id;
        this.profile.isSupport = this.checkSupport();
        this.isLogin = 1;
      } else {
        this.isLogin = 0;
      }
    });
  }

  convertDate(value: number) {
    return moment.unix(value).format('MMMM D, YYYY');
  }

  checkSupport() {
    return (
      this.profile.memberSupports.filter(
        (row: any) => row.member_id == this.appUserId
      ).length > 0
    );
  }
  public bizHasBot = false;
  public subEmail = ''; //substitute email if user is not verified

  public get haveIVerifiedEmail(): boolean {
    //console.log("user is", this.user)
    return this.user.isEmailVerify;
  }

  public getProfileInfo(code: string, isReferral: boolean = false): void {
    this.auth.getShopDetail({ code }).subscribe(
      (response: any) => {
        const profileData = response.body;

        if (!profileData?.id) {
          this.toastr.warning('Invalid Link');
          this.router.navigateByUrl('/biz');
          return;
        }

        this.profile = profileData;
        if (this.profile.w_phone_number?.includes('undefined')) {
          this.profile.w_phone_number = null;
        }
        this.getChatBotData();

        this.sharedService.triggerProfileService(this.profile);
        this.profile.seller_info = JSON.parse(profileData.seller_info);

        this.title.setTitle(`${profileData.shop_name}`);
        this.seoService.update({
          title: profileData.shop_name,
          description: profileData.shop_name,
        });

        this.profile.created = this.convertDate(this.profile.created);
        this.profile.isSupport = this.checkSupport();

        this.getReferralUploadedFiles('gallery', true);

        if (this.profile.holidays) {
          try {
            this.selectedHolidays = JSON.parse(this.profile.holidays);
          } catch (error) {
            console.error('Error parsing holidays:', error);
          }
        }

        if (this.router.url.includes('/share/')) {
          this.seoService.updateNoIndex(true);
        }

        if (isReferral) {
          this.seoService.updateNoIndex(true);
          this.store.dispatch(
            loadBizShopProducts({
              categoryId: '',
              subCategoryId: '',
              adminId: this.profile.user_id,
              search: '',
              page: 1,
              limit: this.window.innerWidth > 991 ? 15 : 6,
            })
          );
          this.store.dispatch(
            loadBizShopBanner({ adminId: this.profile.user_id })
          );
        }

        this.loading = false;
      },
      (error) => {
        console.error('Error fetching profile info:', error);
        this.toastr.warning('Invalid Link');
        this.router.navigateByUrl('/biz');
      }
    );
  }

  spendingTotal: number = 0;
  galleryCount: number = 0;
  voucherCount: number = 0;
  getReferralUploadedFiles(category: string = 'gallery', init = false) {
    if (this.category == 'news' && category == 'news') {
      this.initNews();
      return;
    }

    this.auth
      .userReferralUploadedFile(this.profile.id, category, this.referralCode)
      .subscribe((response: any) => {
        this.userReferralUploadedFile = response.body.data;
        this.spendingTotal = response.body.spendingTotal;

        if (category == 'gallery') {
          this.galleryCount = this.userReferralUploadedFile.length;
        }
        if (category == 'voucher') {
          this.voucherCount = this.userReferralUploadedFile.length;
        }

        if (init) {
          this.refferalCategories = [
            { title: 'news', condition: this.profile.news_count > 0 },
            { title: 'gallery' },
            { title: 'cashback', condition: this.profile.cashback_count > 0 },
            { title: 'voucher', condition: this.profile.voucher_count > 0 },
          ];
        }
      });
  }

  news: any = [];
  initNews() {
    this.auth
      .shop_business_get_news(this.profile.user_id)
      .subscribe((response: any) => {
        this.news = response.body;
      });
  }

  tabChangeReferralFiles(tab: any) {
    this.category = this.refferalCategories[tab].title;
    this.getReferralUploadedFiles(this.category);
  }

  referral: any = {};
  public getReferralInfo(code: any) {
    this.auth.userReferralByCode(code).subscribe(
      (response: any) => {
        this.referral = response.body;
        if (this.referral?.userId == 0) {
          this.referralCode = '';
        }
        if (this.referral) {
          this.getProfileInfo(this.referral.shopId, true);
        } else {
          this.toastr.warning('Referral Link Invalid');
          this.router.navigateByUrl('/biz');
          return;
        }
      },
      (e) => {
        this.toastr.warning('Referral Link Invalid');
        this.router.navigateByUrl('/biz');
        return;
      }
    );
  }

  public handleSupportSeller() {
    if (!this.isLogin) {
      this.toastr.error('Please Login First!');
      return;
    }
    /////////////////
    // if (this.profile.isSupport) {
    //   this.toastr.info('Already supported');
    //   return;
    // }
    this.local
      .confirm({
        title: 'Support',
        text: this.profile.isSupport
          ? 'Are you sure you want to unsupport this bussiness'
          : 'This biz will be saved to your profile',
        icon: 'info',
      })
      .then((resp) => {
        if (resp.isConfirmed) {
          this.customerService
            .addMemberSupport({
              businessId: this.profile.user_id,
              type: 'biz',
            })
            .subscribe({
              next: (response: any) => {
                // if (response.body) {
                //   this.profile.isSupport = true;
                // } else {
                //   this.profile.isSupport = false;
                // }
                this.profile.isSupport = !this.profile.isSupport;
                this.toastr.success(response.message);
              },
              error: (e) => {
                this.toastr.error(e.error.message);
              },
            });
        } else {
          this.toastr.info('Support cancelled');
        }
      });

    //////////
  }

  public getAllBizShopProductList(cate, subCate, page = 1, search = '') {
    this.page = page;
    if (page === 1) {
      this.loadingProduct = true;
    }
    this.store.dispatch(
      loadBizShopProducts({
        categoryId: cate?.id || '',
        subCategoryId: subCate?.id || '',
        adminId: this.shopAdminId || this.profile.user_id,
        search: search,
        page: this.page,
        limit: this.window.innerWidth > 991 ? 15 : 6,
      })
    );
  }

  readmore = false;
  readMore() {
    this.readmore = true;
    this.getAllBizShopProductList(
      this.selectedCatId,
      this.selectedSubCatId,
      this.currentPage + 1
    );
  }

  public productAllProductListFiltered: Array<any> = [];
  public filterProduct(event: any) {
    this.getAllBizShopProductList(
      this.selectedCatId,
      this.selectedSubCatId,
      1,
      event.target.value.toLowerCase()
    );
  }

  featchMainCate(cate) {
    this.selectedSubCatId = {};
    if (this.selectedCatId.id == cate.id) {
      this.selectedCatId = {};
      this.getAllBizShopProductList({}, {});
      return;
    }
    this.selectedCatId = cate;
    this.getAllBizShopProductList(cate, {});
    this.getAllSubCategories(cate.id);
  }
  featchSubCate(cate, subCate) {
    this.selectedSubCatId = subCate;
    this.getAllBizShopProductList(cate, subCate);
  }

  categories: any = [];
  subcategories: any = [];
  selectedCatId: any = {};
  selectedSubCatId: any = {};
  getAllCategories(id): Observable<any> {
    return this.auth.getFoodCategories(id);
  }
  getAllSubCategories(cate) {
    this.loadingCate = true;
    const formData = new FormData();

    formData.append('categoryId', cate);

    this.auth.getFoodSubCategories(formData).subscribe(
      (response: any) => {
        this.subcategories = response.body;
        this.subcategories.unshift({
          name: 'ALL',
          title: 'ALL',
        });
        this.loadingCate = false;
      },
      (e) => {}
    );
  }

  public viewProductDetails(product): void {
    this.marketplaceProfileSection.viewProduct(product);
  }

  referralLink: string = '';
  shareType = '';
  referFriendLink(share = false) {
    const user = this.local.getUser();
    if (!user?.referralCode) {
      this.toastr.error('Please Login to Get Referral Code');
      return;
    }

    this.auth
      .userReferralAdd({
        userId: user.id,
        referralCode: user.referralCode,
        shopName: this.profile.shop_name,
        shopId: this.profile.id,
      })
      .subscribe((response: any) => {
        // Get the text field
        // var copyText = document.getElementById("myInput");

        try {
          this.referralLink = `${environment.baseUrl}brand?code=${response.body.referralCode}`;
          this.clipboard.copy(this.referralLink);

          if (!share) this.toastr.success('Copied Referral Link to clipboard');
          else this.shareContent(this.referralLink);
        } catch (err) {
          if (!share) {
            this.toastr.error(err.message);
            this.toastr.error('Failed to copy referral link');
          }
        }
      });
  }
  copyURL(share = false): void {
    if (this.shareType == 'referral') return this.referFriendLink(share);
    // Create a textarea element
    const textArea = document.createElement('textarea');

    // Get the current page URL
    this.referralLink = textArea.value = this.window.location.href.replaceAll(
      '/biz/shop/',
      '/share/'
    );

    // Add the textarea to the document
    document.body.appendChild(textArea);

    // Select the text
    textArea.select();

    try {
      // Execute the copy command
      const successful = document.execCommand('copy');
      const msg = successful ? 'successful' : 'unsuccessful';
      if (!share) this.toastr.success(`URL copied to clipboard`);
      else this.shareContent(this.referralLink);
    } catch (err) {
      console.error('Error copying URL: ', err);
    }

    // Remove the textarea from the document
    document.body.removeChild(textArea);
  }
  copyToClipboard(el, referralCode = null) {
    // resolve the element
    el = typeof el === 'string' ? document.querySelector(el) : el;
    // handle iOS as a special case
    if (navigator.userAgent.match(/ipad|ipod|iphone/i)) {
      // save current contentEditable/readOnly status
      var editable = el.contentEditable;
      var readOnly = el.readOnly;

      // convert to editable with readonly to stop iOS keyboard opening
      el.contentEditable = true;
      el.readOnly = true;

      // create a selectable range
      var range = document.createRange();
      range.selectNodeContents(el);

      var selection = this.window.getSelection();
      selection.removeAllRanges();
      selection.addRange(range);

      // restore contentEditable/readOnly to original state
      el.contentEditable = editable;
      el.readOnly = readOnly;
      document.execCommand('copy');
      let strin = referralCode ?? el.innerText;
      this.toastr.success(`Copied ${strin} to clipboard`);
    } else {
      var range = document.createRange();
      range.selectNodeContents(el);
      var selection = this.window.getSelection();
      selection.removeAllRanges();
      selection.addRange(range);
    }

    // execute copy command
    document.execCommand('copy');
  }

  openedUploadFileModal: boolean = false;

  @ViewChild('UploadFileModal') uploadFileModal: TemplateRef<any>;

  openUploadFileModal() {
    if (
      !this.openedUploadFileModal &&
      this.referralCode &&
      this.appUserId != this.referral.userId &&
      this.isLogin == 1
    ) {
      setTimeout(() => {
        this.openedUploadFileModal = true;
        this.auth
          .userReferralUploadFile(this.referralCode)
          .subscribe((response: any) => {
            if (response.body == null) {
              this.modalService.open(this.uploadFileModal, {
                windowClass: 'my-upload-file-modal',
                // backdrop: 'static',
                keyboard: false,
              });
            }
          });
      }, 1000);
    }
  }
  showImageGallery: any = {};
  openShowImageModal(modal, image) {
    if (!this.user?.isEmailVerify) {
      this.toastr.error('Please verify your email');
      return;
    }
    this.showImageGallery = image;
    this.modalService.open(modal, {
      windowClass: 'my-show-image-modal',
    });
  }

  buttonUpload() {
    this.modalService.open(this.uploadFileModal, {
      windowClass: 'my-upload-file-modal',
      // backdrop: 'static',
      keyboard: false,
    });
  }
  fileUpload: File | null = null;
  thumbnail: string | null = null;
  onFileSelected(event: any) {
    this.fileUpload = null;
    this.thumbnail = null;
    const file: File = event.target.files[0];
    if (file) {
      if (this.isPhoto && file.type.startsWith('image/')) {
        this.fileUpload = file;
        const reader = new FileReader();
        reader.onload = (e: any) => {
          this.thumbnail = e.target.result;
        };
        reader.readAsDataURL(file);
        this.toastr.success(`Selected image file: ${file.name}`);
      } else if (!this.isPhoto && file.type.startsWith('video/')) {
        this.fileUpload = file;
        const reader = new FileReader();
        reader.onload = (e: any) => {
          this.thumbnail = e.target.result;
        };
        reader.readAsDataURL(file);
        this.toastr.success(`Selected video file: ${file.name}`);
      } else {
        this.toastr.warning(
          `Please select a ${this.isPhoto ? 'image' : 'video'} file`
        );
      }
    } else {
      this.toastr.warning('No file selected');
    }
  }
  onFileSelectedCashback(event: any, data: any) {
    const file: File = event.target.files[0];
    if (file) {
      if (this.isPhoto && file.type.startsWith('image/')) {
        data.fileUpload = file;
        const reader = new FileReader();
        reader.onload = (e: any) => {
          data.thumbnail = e.target.result;
        };
        reader.readAsDataURL(file);
        this.toastr.success(`Selected image file: ${file.name}`);
      } else if (!this.isPhoto && file.type.startsWith('video/')) {
        data.fileUpload = file;
        const reader = new FileReader();
        reader.onload = (e: any) => {
          data.thumbnail = e.target.result;
        };
        reader.readAsDataURL(file);
        this.toastr.success(`Selected video file: ${file.name}`);
      } else {
        this.toastr.warning(
          `Please select a ${this.isPhoto ? 'image' : 'video'} file`
        );
      }
    } else {
      this.toastr.warning('No file selected');
    }
  }

  isUploading: boolean = false;
  uploadProgress: number = 0;
  fileDescription: string = '';
  handleUpload() {
    if (this.fileUpload == null) {
      this.toastr.warning('No file selected');
      return;
    }

    const payload = new FormData();
    payload.append('file', this.fileUpload as Blob);
    if (this.referralCode) {
      payload.append('referralCode', this.referralCode);
    } else {
      payload.append('shopId', this.profile.id);
    }
    payload.append('description', this.fileDescription);

    this.isUploading = true;
    this.uploadProgress = 0; // Initialize upload progress

    this.auth
      .userReferralUploadFileStore(payload, {
        reportProgress: true,
        observe: 'events',
      })
      .subscribe(
        (event: any) => {
          if (event.type === HttpEventType.UploadProgress) {
            // Update progress percentage
            this.uploadProgress = Math.round(
              (100 * event.loaded) / event.total
            );
          } else if (event.type === HttpEventType.Response) {
            // Handle response after upload is complete
            this.modalService.dismissAll();
            this.toastr.success('Uploaded successfully');
            this.isUploading = false;
            this.uploadProgress = 0;

            this.fileUpload = null;
            this.thumbnail = null;
            this.fileDescription = '';
            this.getReferralUploadedFiles();
          }
        },
        (error) => {
          this.toastr.error(error.error.message);
          this.isUploading = false;
          this.uploadProgress = 0;
        }
      );
  }
  getStatusMessage(file: any): string {
    if (file.status === 0) {
      return 'Under Review';
    } else if (file.status === 1) {
      const discount = this.calculateDiscount(file);
      return `Approved! You got $${discount} ${file.category}!`;
    } else {
      return `Rejected! Sorry, you are not eligible for this ${file.category}`;
    }
  }

  calculateDiscount(file: any): number {
    let discount = file.discount ?? 0;
    return file.haveReferrer && file.discount !== 0 ? discount / 2 : discount;
  }

  dataDetail: any = {};
  @ViewChild('VerifEmailPopup') VerifEmailPopup: VerifyEmailPopupComponent;
  async handleClaim(id: string, category: string = 'voucher', data: any) {
    if (
      this.user?.email == null ||
      this.user?.email == '' ||
      !this.user?.isEmailVerify
    ) {
      this.toastr.warning('Please verify your email first');
      this.VerifEmailPopup.openPopup();
      return;
    }

    if (category == 'voucher' || category == 'cashback') {
      this.dataDetail = data;
      if (this.dataDetail.receiptFile) {
        this.dataDetail.thumbnail = this.imgUrl + this.dataDetail.receiptFile;
      }
      this.modalService.open(this.VoucherTermsAndConditionsModal, {
        windowClass: 'terms-and-conditions my-modal sm',
        // backdrop: 'static',
        keyboard: false,
      });
      return;
    }
  }

  outletCode: string = '';
  isClaiming: boolean = false;
  processClaim(id: any) {
    this.local
      .alertConfirm({
        message: `Are you sure you want to claim this ${this.category}?`,
      })
      .then((confirm) => {
        if (confirm.isConfirmed) {
          let formData = new FormData();
          formData.append('businessId', id);
          formData.append('referralCode', this.referralCode);
          formData.append('shopId', this.profile.id);
          formData.append('outletCode', this.outletCode);
          formData.append('category', this.dataDetail.category);
          formData.append('subEmail', this.subEmail);

          if (this.dataDetail.category == 'cashback') {
            if (!this.dataDetail.fileUpload) {
              this.toastr.error('Please upload a receipt');
              return;
            }
            formData.append('receiptFile', this.dataDetail.fileUpload as Blob);
            if (this.dataDetail.valueReceipt) {
              formData.append('receiptValue', this.dataDetail.valueReceipt);
            }
            if (this.dataDetail.noReceipt) {
              formData.append('receiptNo', this.dataDetail.noReceipt);
            }
          }
          this.isClaiming = true;

          this.auth.userReferralClaim(formData).subscribe(
            (response: any) => {
              this.isClaiming = false;
              this.modalService.dismissAll();
              this.toastr.success('Claimed successfully');
              this.getReferralUploadedFiles(this.category);
            },
            (e) => {
              this.isClaiming = false;
              this.toastr.error(e.error.message);
            }
          );
        }
      });
  }

  handleDelete(id: any) {
    this.local
      .alertConfirm({
        message: `Are you sure you want to delete this ${this.category}?`,
      })
      .then((res: any) => {
        if (res.isConfirmed) {
          this.auth.shop_business_delete(id).subscribe(
            (response: any) => {
              this.toastr.success('Deleted successfully');
              this.getReferralUploadedFiles(this.category);
            },
            (e) => {
              this.toastr.error(e.error.message);
            }
          );
        }
      });
  }

  handleReport(id: any, category = null) {
    this.local.alertReport().then((result) => {
      if (result.isConfirmed && result.value) {
        const report = result.value;
        this.auth
          .submitReportMessage({
            message: report.reportDetails,
            type: report.reportType,
            category: category ?? this.category,
            product_id: id,
          })
          .subscribe(
            (response: any) => {
              this.toastr.success('Reported successfully');
            },
            (e) => {
              this.toastr.error(e.error.message);
            }
          );
      }
    });
  }
  handleSuggestion(id: any, category = null) {
    this.local.alertSuggestion('Suggest').then((result) => {
      if (result.isConfirmed && result.value) {
        const report = result.value;
        this.auth
          .submitSuggestionMessage({
            message: report.reportDetails,
            type: category ?? this.category,
            product_id: id,
          })
          .subscribe(
            (response: any) => {
              this.toastr.success('Suggested successfully');
            },
            (e) => {
              this.toastr.error(e.error.message);
            }
          );
      }
    });
  }
  public memberList: Array<any> = [];
  public getShopMember(id): Observable<any> {
    return this.auth.getShopMembers(id);
  }
  scrollTo(index) {
    const element = document.getElementById('shop-tabs');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    this.tabCategorie = index;
  }

  public today = new Date();
  public selectedHolidays: any = [];
  public openHolidayPopUp(modal) {
    this.modalService.open(modal, {
      size: 'sm',
      ariaLabelledBy: 'modal-basic-title',
      windowClass: 'suggestion',
    });
  }

  public isSelected(date: NgbDateStruct): boolean {
    return this.selectedHolidays
      ? this.selectedHolidays.some((d) => this.dateEquals(d, date))
      : false;
  }

  dateEquals(date1: NgbDateStruct, date2: NgbDateStruct): boolean {
    return (
      date1.year === date2.year &&
      date1.month === date2.month &&
      date1.day === date2.day
    );
  }

  handleWhatsapp() {
    this.local
      .alertConfirm({
        message: 'Are you sure you want to send a whatsapp message?',
      })
      .then((res: any) => {
        if (res.isConfirmed) {
          window.open(`https://wa.me/${this.profile.w_phone_number}`, '_blank');
        }
      });
  }

  elementType: 'url';
  QrCodeValue: string;
  shopWebLink: string = `${this.window.origin}/#/biz/`;
  openQRCodeModal(modal: any) {
    this.QrCodeValue = `${this.shopWebLink}${
      this.profile.shop_name ?? this.profile.id
    }`;
    this.modalService.open(modal, {
      windowClass: 'my-modal sm',
      // backdrop: 'static',
      keyboard: false,
    });
  }

  handleGalleryLikes(item: any) {
    this.customerService
      .galleryLikes({
        businessId: item.id,
      })
      .subscribe(
        (response: any) => {
          item.isLikes = !item.isLikes;
          this.toastr.success('Liked successfully');
        },
        (e) => {
          this.toastr.error(e.error.message);
        }
      );
  }

  ngOnDestroy(): void {
    // Emit to unsubscribe
    this.destroy$.next();
    this.destroy$.complete();
    this._roleSubscription?.unsubscribe();
  }

  private async wait(mili) {
    return new Promise((res, _) => {
      setTimeout(res, mili);
    });
  }

  async shareContent(link?: string) {
    this.auth.getBizInfo(this.profile.id).subscribe({
      next: async (data: any) => {
        this.currBizCard = data.user;
        const imageDiv = document.getElementById('card-image');
        if (!imageDiv) {
          console.error('Unable to find card');
          this.toastr.error('Something went wrong while sharing!');
          return;
        }

        this.toastr.info('Loading...');

        imageDiv.style.visibility = 'visible';
        imageDiv.style.position = 'absolute';
        await this.wait(500);
        //imageDiv.style.left = '-9999px';

        const scale = 4; // Increase resolution
        const options = {
          quality: 1,
          width: imageDiv.offsetWidth * scale,
          height: imageDiv.offsetHeight * scale,
          style: {
            transform: `scale(${scale})`,
            transformOrigin: 'top left',
          },
          useCors: true,
          cacheBust: true,
        };

        domtoimage
          .toJpeg(imageDiv, options)
          .then((dataUrl) => {
            setTimeout(() => {
              imageDiv.style.visibility = 'hidden';
            }, 0);

            console.log('Sharing image with URL:', dataUrl);

            if (navigator.share) {
              fetch(dataUrl)
                .then((res) => res.blob())
                .then((blob) => {
                  const file = new File([blob], 'image.jpg', {
                    type: 'image/jpeg',
                  });

                  navigator
                    .share({
                      title: this.profile?.shop_name || 'Check this out!',
                      url: this.profile?.shop_link || '',
                      files: [file], // Attach image file
                    })
                    .then(() => console.log('Shared successfully'))
                    .catch(console.error);
                })
                .catch(console.error);
            } else {
              alert('Web Share API is not supported in your browser.');
            }
          })
          .catch((error) => {
            imageDiv.style.visibility = 'hidden';
            console.error('Error creating image:', error);
          });
      },
      error: (err) => {
        console.error(err);
        this.toastr.error('Something went wrong while fetching info.');
      },
    });
  }
}
